export default "__VITE_ASSET__nanoDrzc__"